var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.28 104.458L60 84.6625L31.72 104.458L27.2675 100.758L41.235 70.0275L13.2775 50.4525L14.9975 44.995H45.895L57.1725 13.9725H62.8125L74.0975 44.9975H104.995L106.715 50.4525L78.7575 70.0275L92.725 100.758L88.2725 104.458H88.28Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarFilled);
export default __webpack_public_path__ + "static/media/RatingStarFilled.d7dd3631.svg";
export { ForwardRef as ReactComponent };